import HtmlToReact from 'html-to-react';

import { addClosingTags, processingList, changeNot } from './templateHelper';

const HtmlToReactParser = HtmlToReact.Parser;
const htmlToReactParser = new HtmlToReactParser();

const isValidNode = () => true;

const TemplateParser = (props) => {
  const { products, template, settings, collection } = props;
  let newTemplate = addClosingTags(template);
  newTemplate = changeNot(newTemplate);
  return htmlToReactParser.parseWithInstructions(
    newTemplate,
    isValidNode,
    processingList(products, collection, 'List', settings)
  );
};

export default TemplateParser;
